<!--
 * @Author: 田鑫
 * @Date: 2022-01-06 16:52:22
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-13 21:20:22
 * @Description: 包间导入管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'restaurantManagement' }"> 餐厅管理 </el-breadcrumb-item>
        <el-breadcrumb-item>新增包间</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="包间名称：" prop="roomName">
          <el-input style="width: 300px" v-model="listParams.roomName" placeholder="请填写包间名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <span style="line-height: 40px"
              >餐厅名称： <span class="alert-text ft16">{{ queryForm.canteenName }}</span></span
            >
            <el-button style="margin-left: 20px" @click="openDialog('')" type="primary">新增包间</el-button>
            <!-- 本期功能暂时屏蔽 -->
            <!-- <el-button
              style="margin-left: 20px"
              @click="importExcel"
              type="danger"
              >批量新增包间</el-button
            > -->
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" border>
          <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

          <el-table-column label="包间名称" prop="roomName" align="center"></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该包间吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="包间管理" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item label="餐厅名称：">
          <span>{{ queryForm.canteenName }}</span>
        </el-form-item>
        <el-form-item label="包间名称：" prop="roomName">
          <el-input v-model="dialogForm.roomName" placeholder="请填写包间名称" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="包间容量：" prop="capacity">
          <el-input v-model="dialogForm.capacity" placeholder="例如：豪华包间可容纳20人聚餐，也可简单输入：20人" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="包间主图：" prop="mainPicture">
          <oss-uploader @setImage="getImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        roomName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      queryForm: {
        canteenId: "",
        canteenName: "",
      },
      dialogForm: {
        roomName: "",
        capacity: "",
        mainPicture: "",
      },
      dialogRules: {
        roomName: [{ required: true, message: "请填写包间名称", trigger: "blur" }],
        capacity: [{ required: true, message: "请填写包间容量", trigger: "blur" }],
      },
      isDisabled: false,
      previewList: [],
      method: "",
    };
  },

  mounted() {
    this.queryForm.canteenName = this.$route.query.name;
    this.queryForm.canteenId = this.$route.query.id;
    this.loadTableData();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager, {
        canteenName: this.queryForm.canteenName,
      });
      this.$http({
        url: global.apiUrl + "/room",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑餐厅
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + "/room/detail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            if (this.dialogForm.mainPicture) {
              this.previewList = [this.dialogForm.mainPicture];
            }
            this.openDialog(id);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除餐厅
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/room",
        method: "DELETE",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    openDialog(id) {
      if (id) {
        this.method = "PUT";
      } else {
        //* 还原表单
        this.dialogForm = this.$options.data().dialogForm;
        this.previewList = [];
        this.method = "POST";
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 批量导入
     * @param {*}
     * @return {*}
     */
    importExcel() {},
    /**
     * @description: 获取图片列表
     * @param {*} file
     * @return {*}
     */
    getImage(file) {
      this.dialogForm.mainPicture = file;
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign(this.dialogForm, this.queryForm);
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + "/room",
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                //* 还原表单
                this.dialogForm = this.$options.data().dialogForm;
                this.previewList = [];
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
